import { baseDateComparator } from '@instinet-analytics/core-lib';
import Column, { getBaseColumn } from './Column';
import ColumnType from './ColumnType';
import SortType from './SortType';
import { timeFormatUtils } from '@instinet-analytics/core-lib';

const { toDate, toDateTimeSeconds, toTimeSeconds } = timeFormatUtils;

const baseDateColumn: Partial<Column<ColumnType.DATE>> = {
    ...getBaseColumn(ColumnType.DATE),
    sortCompareFunction: baseDateComparator,
    defaultSortDesc: true,
};

export const arrivalPTime = {
    ...baseDateColumn,
    name: 'Arrival Time',
    dataField: 'arrivalPTime',
    width: 80,
    tag: 'Order Data/Arrival Price Time',
    desc: 'Time arrival price was set',
    labelFunction: toDateTimeSeconds,
};

export const fillT = {
    ...baseDateColumn,
    name: 'Fill Time',
    dataField: 'fillT',
    width: 80,
    tag: 'Order Data/Fill Time',
    desc: 'Time of last fill',
    labelFunction: toTimeSeconds,
    sortType: SortType.BLANK,
};

export const timeIn = {
    ...baseDateColumn,
    name: 'Date Time In',
    dataField: 'timeIn',
    width: 114,
    tag: 'Order Data/Date Time In',
    desc: 'Date and time order sent in by client',
    labelFunction: toDateTimeSeconds,
};

export const timeInT = {
    ...baseDateColumn,
    name: 'Time In',
    dataField: 'timeInT',
    width: 63,
    tag: 'Order Data/Time In',
    desc: 'Time order sent in by client',
    labelFunction: toTimeSeconds,
};

export const timeInD = {
    ...baseDateColumn,
    name: 'Date In',
    dataField: 'timeInD',
    width: 61,
    tag: 'Order Data/Date In',
    desc: 'Date order sent in by client',
    labelFunction: toDate,
};
